import React from 'react';
import './Testimonials.css';

// --- 1. IMPORTAR LAS FOTOS LOCALES AQUÍ ---
// La ruta es relativa: estamos en 'components', entramos a 'fotos_testimonios'
import samuelImg from './fotos_testimonios/samuel.jpg';
import gilbertoImg from './fotos_testimonios/gilberto.jpg';
import isaacImg from './fotos_testimonios/isaac.jpeg';
import sysavaneImg from './fotos_testimonios/sysavane.jpg';
import josueImg from './fotos_testimonios/josue.jpg';
// Si tienes las otras fotos, impórtalas igual. 
// Por ahora usaré placeholders para las que faltan.
// import ulysseImg from './fotos_testimonios/ulysse.jpg'; 

const Testimonials = () => {
  
  const testimonials = [
    {
      id: 1,
      text: "A lo largo de los cursos y webinars de The Bull Miner pude fortalecer mis bases en estimación y modelamiento geológico, pero también aprender nuevas metodologías y enfoques que antes no manejaba. Estos espacios me ayudaron a entender mejor el proceso completo, desde la interpretación hasta la estimación, y a desarrollar un criterio más técnico y aplicado. En general, siento que ahora tengo una visión más clara, práctica y segura para abordar proyectos de carácter riguroso.",
      author: "Samuel Cristobal",
      role: "Estudiante (10mo semestre)", // Separé el rol para que se vea ordenado
      location: "Perú",
      img: samuelImg // <--- 2. USAMOS LA VARIABLE IMPORTADA (Sin comillas)
    },
    {
      id: 2,
      text: "Hola hermanos, me llamo Sy Savané Syndou. Soy de Costa de marfíl. He participado en la formación “Las 12 etapas de la estimación de recursos” impartida por Grupo The Bull Miner. Actualmente me desempeño como Asistente Técnico, especialista en SIG y gestor de bases de datos en el sector minero. Esta formación me ha permitido comprender de manera clara el proceso de estimación de recursos, desde la preparación y validación de datos hasta la estimación y la clasificación de recursos, destacando la importancia de cada etapa para obtener resultados confiables. Esta capacitación representa un aporte importante para mi desarrollo profesional y para la aplicación práctica en proyectos mineros. Agradezco a Grupo The Bull Miner por la calidad de la formación.",
      author: "Sy Savané",
      role: "Asistente Técnico, especialista en SIG y gestor de bases de datos en el sector minero",
      location: "Costa de Marfil",
      img: sysavaneImg // <--- 2. USAMOS LA VARIABLE IMPORTADA (Sin comillas)

    },
    {
      id: 3,
      text: "Las clases de Leapfrog del Inge Demian me han sido de gran ayuda para aprender cómo generar un modelo geológico paso a paso desde cero. Su forma de explicar cada paso ha sido muy clara y fácil de entender, ya que las clases son muy didácticas al compartir los datos y permitirnos seguir el ejercicio junto con él. Espero que siga creando contenido de esta calidad, ya que es de mucha ayuda para aquellos que estamos interesados en aprender este increíble software, que ya es muy utilizado en la industria.",
      author: "Josué Jazziel Salgado Sáenz",
      role: "Geólogo",
      location: "México",
      img: josueImg
    },


    {
      id: 4,
      text: "El Ing.Demian logra plasmar de manera clara y didactica procesos que llevan años de aprender lo cual surge de su experiencia, y esta caracteristica se puede ver en sus clases al momento de explicar los paso a paso, no solo para la estimacion de recursos sino que tambien para el modelado geologico. Claridad y experiencia pueden verse en sus clases.",
      author: "Isaac Reyes",
      role: "Geólogo",
      location: "Argentina",
      img: isaacImg // <--- 2. USAMOS LA VARIABLE IMPORTADA (Sin comillas)

    },

    {
      id: 5,
      text: "Os cursos leccionados, especialmente de estimação de reservas, constituem uma ferramenta excepcional para responder os problemas de modelação geológica.",
      author: "Gilberto Vega",
      role: "Mestrando em Recursos Minerais Sólidos",
      location: "Angola",
      img: gilbertoImg // <--- 2. USAMOS LA VARIABLE IMPORTADA (Sin comillas)

    }
    
  ];

  return (
    <div className="testimonials-grid-container">
      {testimonials.map((item) => (
        <div key={item.id} className="testimonial-card-home">
          <div className="quote-icon">“</div>
          <p className="testimonial-text">{item.text}</p>
          <div className="testimonial-author">
            <img src={item.img} alt={item.author} />
            <div>
              <strong>{item.author}</strong>
              {/* Agregué una pequeña lógica para mostrar el rol si existe */}
              <span style={{display:'block', fontSize:'0.8rem', color:'#2EA043'}}>{item.role}</span>
              <span>{item.location}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Testimonials;